export default __webpack_public_path__ + "static/media/halfProgrammr.61988de0.jpeg";